import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useNavigate, useLocation } from '@remix-run/react';
import { OutletProps } from 'react-router';
import { useGetCurrentUser } from './shared/hooks/useGetCurrentUser';
import { BootScreen } from './widgets/BootScreen/BootScreen';
// import { useGetCars } from './shared/hooks/useGetCars';
// import { useGetCards } from './shared/hooks/useGetCards';

export function WithAuth<P extends OutletProps>(
  WrappedComponent: React.ComponentType<P>
) {
  return function AuthWrapper(props: P) {
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const token = Cookies.get('token');
    const nonRedirectPaths = [
      '/registration',
      '/registration-code',
      '/registration-form',
      'registration-car',
    ];
    const { data, isSuccess } = useGetCurrentUser();
    // const { refetch: refetchCars } = useGetCars();
    // const { refetch: refetchCards } = useGetCards();

    useEffect(() => {
      if (data?.success === false && !location.pathname.includes('payment')) {
        navigate('/registration');
      }
      // else {
      //   refetchCars();
      //   refetchCards();
      // }
      // else if (!cars?.length && !isLoadingCars) {
      //   navigate('/registration-car');
      // }
    }, [isSuccess]);

    useEffect(() => {
      if (
        location.pathname.includes('test') ||
        location.pathname.includes('payment')
      ) {
        setIsLoading(false);
      } else if (token) {
        setIsLoading(false); // Устанавливаем состояние загрузки в false, если токен найден
      } else if (!nonRedirectPaths.includes(location.pathname)) {
        navigate('/registration'); // Переход на страницу регистрации, если мы не на ней
      } else {
        setIsLoading(false); // Если мы уже на странице регистрации, устанавливаем загрузку в false
      }
    }, [token, navigate, location.pathname]);

    if (isLoading) {
      return (
        <div>
          <BootScreen />
        </div>
      );
    }

    // Возвращаем WrappedComponent, если токен существует
    return <WrappedComponent {...props} />;
  };
}
